module.exports = __webpack_public_path__ + "static/img/example-wxxcx.75f736fe.png";